goog.require('el8.shared.util.renderGrowthChart');


var el8 = el8 || {};
if (!el8.main) { el8.main = {}; }
el8.main.serverPrintout = {};


el8.main.serverPrintout.init = function(spec) {

    var tmplArgs = spec['data'];

    // Growth charts need to run an extra, non-soy function to convert the data into a chart.
    // It's a bit of a hack to depend on wkhtmltopdf to run this stuff...
    if (tmplArgs['growthCharts'] && tmplArgs['growthCharts'].length && $('.chart-holder').length) {
        for (var i=0; i < tmplArgs['growthCharts'].length; i++) {
            var $chartHolder = $('.chart-holder[data-index="'+i+'"]');
            el8.shared.util.renderGrowthChart(tmplArgs['growthCharts'][i], $chartHolder, true);
        }
    }

};

